import React from 'react';

import TmoInput from './TmoInput';

function TmoNumberInput(props) {
  return <TmoInput type="number" step="any" {...props} />;
}

export default TmoNumberInput;
